import {createApp} from 'vue'
import App from './App.vue'

import Antd from 'ant-design-vue';
import router from './router/index'
import i18n, { $t } from "@/utils/locales";
import store from '@/store/store'
import { IMaskDirective } from 'vue-imask'

import '@/assets/style/common.less'
import './assets/iconfont/iconfont.css'
import 'ant-design-vue/dist/reset.css';

// 导入自定义组件库
import NsCommon from '@/components/ns-common'

const app = createApp(App);
app.config.globalProperties.$t = $t

app.directive('imask', IMaskDirective)

window.$Captcha = window.initCaptcha({ appKey: 189947538 })
app.config.globalProperties.$Captcha = window.$Captcha

// 按照依赖顺序加载插件
app.use(i18n)   // 先加载国际化
    .use(Antd)   // 再加载 UI 组件库
    .use(router) // 加载路由
    .use(store) // 加载路由
    .use(NsCommon) // 注册自定义组件库
    .mount('#app');

